module.exports = __webpack_public_path__ + "assets/img/23_132_big.adaf06fd.jpg";